import React, { useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { Trash } from "react-feather"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import { deleteEvent } from "../../api/socket/functions"
import { useSelector } from "react-redux"

function DeleteModal({ event }) {
	const { team, comment, id } = event
	const { events } = getSportsConfig(localStorage.getItem("sport"))
	const isDisconnected = useSelector((state) => state.isDisconnected)

	const [isOpen, setIsOpen] = useState(false)

	const onDelete = () => {
		deleteEvent(id)
		setIsOpen(false)
		if (!events) return
	}

	const getWarningMessage = () => {
		if (!events) return <></>
		const selectedEvent =
			events.normal.find((ev) => ev.name === event.event) ??
			events.quick.find((ev) => ev.name === event.event)

		if (!selectedEvent) return <></>
		if (selectedEvent.increment) {
			let { increment } = selectedEvent
			const wasNegative = increment < 0
			if (wasNegative) increment *= -1

			const bodStr = increment == 1 ? "bod" : increment < 5 ? "boda" : "bodova"

			return (
				<p style={{ color: "red" }}>
					Ako se ovaj event izbriše, onda se {increment} {bodStr} oduzima
					{wasNegative ? " protivnicima ekipe" : " ekipi"} {team}.
				</p>
			)
		}
	}

	return (
		<>
			<Button.Ripple
				className={"btn-icon rounded-circle"}
				size="sm"
				onClick={() => setIsOpen(true)}
				disabled={isDisconnected}
				color={isDisconnected ? "flat-secondary" : "flat-primary"}
			>
				<Trash />
			</Button.Ripple>

			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Jesi li siguran - {event.event}
				</ModalHeader>
				<ModalBody>
					<p>Jesi li siguran da želiš izbrisati event s porukom:</p>
					<p>
						<b>{comment}</b>
					</p>
					{getWarningMessage()}
				</ModalBody>
				<ModalFooter>
					<Button.Ripple color="danger" outline onClick={onDelete}>
						Nastavi
					</Button.Ripple>
					<Button.Ripple
						color="secondary"
						onClick={() => setIsOpen(false)}
					>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default DeleteModal
